import React, { useState } from 'react';
import { Typography, Button, Space, Card, Popconfirm, message, Row, Col } from 'antd';
import { PlusOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import BillList from '../components/Bill/BillList';
import BillFilter from '../components/Bill/BillFilter';
import BillForm from '../components/Bill/BillForm';
import ImportModal from '../components/Bill/ImportModal';
import AlipaySync from '../components/Bill/AlipaySync';
import billService from '../services/bill';

const { Title } = Typography;

const Bills = () => {
  const [filters, setFilters] = useState({});
  const [formVisible, setFormVisible] = useState(false);
  const [importVisible, setImportVisible] = useState(false);
  const [editingBill, setEditingBill] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleting, setDeleting] = useState(false);

  const handleSyncSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleFilter = (newFilters) => {
    setFilters(newFilters);
  };

  const handleAdd = () => {
    setEditingBill(null);
    setFormVisible(true);
  };

  const handleEdit = (bill) => {
    setEditingBill(bill);
    setFormVisible(true);
  };

  const handleFormSuccess = () => {
    setFormVisible(false);
    setEditingBill(null);
    setRefreshKey(prev => prev + 1);
  };

  const handleImportSuccess = () => {
    setImportVisible(false);
    setRefreshKey(prev => prev + 1);
  };

  const handleSelectionChange = (keys) => {
    setSelectedIds(keys);
  };

  const handleBatchDelete = async () => {
    if (selectedIds.length === 0) return;
    
    setDeleting(true);
    try {
      const result = await billService.batchDeleteBills(selectedIds);
      message.success(`成功删除 ${result.deleted} 条记录`);
      setSelectedIds([]);
      setRefreshKey(prev => prev + 1);
    } catch (error) {
      message.error('批量删除失败');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexShrink: 0 }}>
        <Title level={3} style={{ margin: 0 }}>账单管理</Title>
        <Space>
          {selectedIds.length > 0 && (
            <Popconfirm
              title={`确定删除选中的 ${selectedIds.length} 条记录？`}
              onConfirm={handleBatchDelete}
              okText="确定"
              cancelText="取消"
            >
              <Button danger icon={<DeleteOutlined />} loading={deleting}>
                批量删除 ({selectedIds.length})
              </Button>
            </Popconfirm>
          )}
          <Button icon={<UploadOutlined />} onClick={() => setImportVisible(true)}>
            导入账单
          </Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
            新增账单
          </Button>
        </Space>
      </div>
      
      <Card 
        style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }} 
        styles={{ body: { flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, padding: '16px 24px' } }}
      >
        {/* 支付宝同步 - 顶部一行 */}
        <div style={{ flexShrink: 0, marginBottom: 12, paddingBottom: 12, borderBottom: '1px solid #f0f0f0' }}>
          <AlipaySync onSyncSuccess={handleSyncSuccess} />
        </div>
        <div style={{ flexShrink: 0, marginBottom: 16 }}>
          <BillFilter onFilter={handleFilter} />
        </div>
        <div style={{ flex: 1, minHeight: 0 }}>
          <BillList 
            filters={filters} 
            onEdit={handleEdit} 
            refreshKey={refreshKey}
            onSelectionChange={handleSelectionChange}
          />
        </div>
      </Card>
      
      <BillForm
        visible={formVisible}
        bill={editingBill}
        onCancel={() => setFormVisible(false)}
        onSuccess={handleFormSuccess}
      />
      
      <ImportModal
        visible={importVisible}
        onCancel={() => setImportVisible(false)}
        onSuccess={handleImportSuccess}
      />
    </div>
  );
};

export default Bills;
